import Mutations from '../../odata/mutations';

export default { ...new Mutations('salesOrder'), ...new Mutations('salesOrders') };
